import React, { useState, useEffect } from "react";

import {
  Modal,
  Button,
  Form,
  Container,
  Col,
  Alert,
  Row,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Department } from "../../models/Department";

type AddDepartmentModalProps = {
  show: boolean;
  handleClose: () => void;
  handleSave: (label: string, fullLabel: string) => void;
  existingDepartment: string[];
  department?: Department | null;
};

const DepartmentModal: React.FC<AddDepartmentModalProps> = ({
  show,
  handleClose,
  handleSave,
  existingDepartment,
  department,
}) => {
  const [departmentLable, setDepartmentLable] = useState<string>("");
  const [fullDepartmentLable, setFullDepartmentLable] = useState<string>("1.");
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    setFullDepartmentLable(`1. ${departmentLable?.toUpperCase() || ""}`.trim());
  }, [departmentLable]);

  useEffect(() => {
    if (show) {
      setDepartmentLable(department?.label?.toUpperCase() || "");
      setFullDepartmentLable(
        `1. ${department?.label?.toUpperCase() || ""}`.trim()
      );

      setError(null);
    }
  }, [show, department]);

  const handleSaveClick = () => {
    if (!departmentLable || departmentLable === "") {
      setError(t("common.departmentList.missingLabelAlert"));
      return;
    }

    if (
      existingDepartment?.some(
        (v) => v.trim().toUpperCase() === departmentLable
      )
    ) {
      setError(t("common.departmentList.duplicateLabelAlert"));
      return;
    }

    handleSave(departmentLable, fullDepartmentLable);
    handleClose();
  };

  return (
    <Modal
      size="lg"
      backdrop="static"
      centered
      animation={false}
      show={show}
      onHide={handleClose}
    >
      <Modal.Header>
        <Modal.Title>
          {department?.id === 0
            ? t("common.departmentList.modalHeaderEdit")
            : t("common.departmentList.modalHeaderAddNew")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Alert variant="warning">
            {t("common.departmentList.modalWarning")}
          </Alert>

          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm={3}>
                {t("common.departmentList.departmentLabel")}
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  value={departmentLable}
                  onChange={(e) =>
                    setDepartmentLable(e.target.value?.trim().toUpperCase())
                  }
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                {t("common.departmentList.fullLabelDepartment")}
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  value={fullDepartmentLable}
                  readOnly
                />
              </Col>
            </Form.Group>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} size="sm">
          {t("common.quit")}
        </Button>
        <Button variant="primary" onClick={handleSaveClick} size="sm">
          {t("common.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentModal;
